import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import Checkbox from 'components/UI/V3/Forms/Checkbox';
import { FunctionComponent } from 'react';
import { bookedAtSorter, clientSorter, petSorter, serviceSorter, staffSorter, totalSorter } from './sorting';
import HeaderTableColumn from './HeaderTableColumn';
import { Sorter } from '@spike/appointments-list-model';
import styles from './WalkingHeaderTable.module.scss';

interface WalkingHeaderTableProps {
    sorter: Sorter | null;
    onSort?: (sorter: Sorter) => void;
    allSelected?: boolean;
    onToggleSelectAll?: (checked: boolean) => void;
}

export const WalkingHeaderTable: FunctionComponent<WalkingHeaderTableProps> = props => {
    return (
        <TableHeader>
            {props.onToggleSelectAll && (
                <TableHeaderCell className={styles.checkboxCell}>
                    <Checkbox
                        checked={props.allSelected}
                        onChange={props.onToggleSelectAll}
                    />
                </TableHeaderCell>
            )}
            <HeaderTableColumn
                columnSorter={clientSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Client Name
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={petSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Pet Name
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={serviceSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Service
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={staffSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Staff
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={bookedAtSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Date & Time
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={totalSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Total
            </HeaderTableColumn>
        </TableHeader>
    );
};

export default WalkingHeaderTable;
